<div class="kpmg-navbar">
    <div class="navbar navbar-expand-sm navbar-top">
        <div *ngIf="topNavigationService.getStudyNav()">
            <ul class="center-menu-list navbar-nav kpmg-navbar-megamenu mr-auto top-nav-list">
                <li [routerLink]="getNavigatorRouterLink()"
                    [ngClass]="{active: isNavigatorActive$ | async}"
                    *ngIf="!topNavigationService.getIsClientManager() && !topNavigationService.getIsClientUser()">
                    <div role="button" class="nav-link-item" id="" title="Navigator" aria-label="Info">
                        <div class="topnav-icon"><img src="../assets/Icon-navigator.svg" /></div>
                        <div class="nav-label">NAVIGATOR</div>
                    </div>
                </li>

                <li [ngClass]="{active: isDataImportActive$ | async}" class="dropdown center-menu-list"
                    *ngIf="!topNavigationService.getIsClientManager() && !topNavigationService.getIsClientUser()">
                    <div data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" tabindex="0"
                        class="dropdown-toggle nav-link-item" id="" title="Data Import" aria-label="Info">
                        <div class="topnav-icon"><img src="../assets/Icon-data analysis.svg" /></div>
                        <div class="nav-label">DATA IMPORT</div>
                    </div>
                    <div class="dropdown-menu">
                        <div class="info-menu">
                            <div class="menu-heading">Data Import</div>
                            <ul class="admin__nav">
                                <li routerLinkActive="active" (click)=navigateByEngId(ROUTE_URLs.EMPLOYEE_DATA)>
                                    <a>Import Employees</a>
                                </li>
                                <li routerLinkActive="active" (click)=navigateByEngId(ROUTE_URLs.LEGAL_ENTITY)>
                                    <a>Entities</a>
                                </li>
                                <li routerLinkActive="active" (click)=navigateByEngId(ROUTE_URLs.MANAGE_BUSINESS_COMPONENT)>
                                    <a>Business Components</a>
                                </li>
                                <!-- <li routerLinkActive="active" (click)=navigateByEngId(ROUTE_URLs.MANAGE_PROJECT)>
                                <a>Projects & Activities </a>
                            </li> -->
                                <ul class="admin__nav">
                                    <li routerLinkActive="active" (click)=navigateByEngId(ROUTE_URLs.MANAGE_ACTIVITY)>
                                        <a>Select Activities</a>
                                    </li>
                                </ul>
                                <li routerLinkActive="active" (click)=navigateByEngId(ROUTE_URLs.TIME_TRACKING_DATA)>
                                    <a>Import Time Tracking</a>
                                </li>
                                <li routerLinkActive="active" (click)=navigateByEngId(ROUTE_URLs.EXPENSE_DATA)>
                                    <a>Import Expenses</a>
                                </li>
                                <li *ngIf="topNavigationService.getEnableAgileAnalyzer===true" routerLinkActive="active"
                                    (click)=navigateByEngId(ROUTE_URLs.AGILE_ANALYZER)>
                                    <a>Agile Analyzer</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>

                <li *ngIf="!topNavigationService.getIsClientUser()"
                    [ngClass]="{active: isSurveysActive$ | async}"
                    class="dropdown center-menu-list">
                    <div role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" tabindex="0"
                        class="dropdown-toggle nav-link-item" id="" title="Surveys" aria-label="Surveys">
                        <div class="topnav-icon"><img src="../assets/Icon-surveys.svg" /></div>
                        <div class="nav-label">SURVEYS</div>
                    </div>
                    <div class="dropdown-menu">
                        <div class="info-menu">
                            <div class="menu-heading">Surveys</div>
                            <ul class="admin__nav">
                                <li routerLinkActive="active" (click)=navigateByEngId(ROUTE_URLs.WAGE_SURVEY_LIST)>
                                    <a>Time Surveys</a>
                                </li>
                                <li routerLinkActive="active" (click)=navigateByEngId(ROUTE_URLs.EXPENSE_SURVEY)>
                                    <a>Expense Surveys</a>
                                </li>
                                <li routerLinkActive="active" (click)=navigateByEngId(ROUTE_URLs.PROJECT_SURVEY_LIST)>
                                    <a>Qualitative Surveys</a>
                                </li>
                                <li routerLinkActive="active" (click)=goToReconciliationPage() *ngIf="!topNavigationService.getIsClientManager() && !topNavigationService.getIsClientUser()">
                                    <a>Reconcile Survey</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>

                <li [ngClass]="{active: isInterviewsActive$ | async}" 
                    *ngIf="!topNavigationService.getIsClientManager() && !topNavigationService.getIsClientUser() && !topNavigationService.getIsClientAdmin()"
                    [routerLink]="getInterviewRouterLink()">
                    <div role="button" class="nav-link-item" id="" title="Interviews" aria-label="Info">
                        <div class="topnav-icon"><img src="../assets/Icon-interviews.svg" /></div>
                        <div class="nav-label">INTERVIEWS</div>
                    </div>
                </li>

                <li [ngClass]="{active: isReportsActive$ | async}" class="dropdown center-menu-list"
                    *ngIf="!topNavigationService.getIsClientManager() && !topNavigationService.getIsClientUser()">
                    <div data-toggle="dropdown" class="dropdown-toggle nav-link-item" role="button" aria-haspopup="true"
                        aria-expanded="false" id="" title="Reports" aria-label="Reports" tabindex="0">
                        <div class="topnav-icon"><img src="../assets/Icon-reports.svg" /></div>
                        <div class="nav-label">REVIEW & REPORTS</div>
                    </div>
                    <div class="dropdown-menu">
                        <div class="info-menu">
                            <div class="menu-heading">Reports</div>
                            <ul class="admin__nav">
                                <li routerLinkActive="active" (click)=navigateByEngId(ROUTE_URLs.QNQ_REVIEW)>
                                    <a>Reviews</a>
                                </li>
                                <li routerLinkActive="active" (click)=navigateByEngId(ROUTE_URLs.QRE_REPORTS)>
                                    <a>Reports</a>
                                </li>
                                <li *ngIf="!topNavigationService.getIsClientAdmin()" routerLinkActive="active"
                                    (click)=navigateByEngId(ROUTE_URLs.TEMPLATE_MEMO_GENERATOR)>
                                    <a>Template Memo
                                        Generator</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>

                <li *ngIf="!topNavigationService.getIsClientUser()" [ngClass]="{active: isDocumentsActive$ | async}"
                    class="dropdown center-menu-list" (click)=navigateByEngId(ROUTE_URLs.MANAGE_DOCUMENTS)>
                    <div role="button" class="nav-link-item" id="" title="Documents" aria-label="Info">
                        <div class="topnav-icon"><img src="../assets/Icon-docs.svg" /></div>
                        <div class="nav-label">DOCUMENTS</div>
                    </div>
                </li>

                <li *ngIf="!topNavigationService.getIsClientUser() && !(topNavigationService.getIsClientManager() && !topNavigationService.getClientManagerInsightAccess())" [ngClass]="{active: isInsightsActive$ | async}"
                       class="dropdown center-menu-list" (click)=navigateByEngId(ROUTE_URLs.DASHBOARD_INSIGHTS)>
                    <div role="button" class="dropdown-toggle nav-link-item" id="" title="Insights" aria-label="Info">
                        <div class="topnav-icon"><img src="../assets/Icon-insights.svg" /></div>
                        <div class="nav-label">INSIGHTS</div>
                    </div>
                </li>
            </ul>

        </div>
    </div>
</div>
